import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import UserSubscriptionDetailsModal from "../models/UserSubscriptionDetailsModal";

const UsersSubscriptionDetails = () => {
  const [dropdownData, setDropdownData] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [loadingDropdown, setLoadingDropdown] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const[selectedRow, setSelectedRow] = useState(null);
  const[openModal, setOpenModal] =  useState(false);
  useEffect(() => {
    const fetchDropdownData = async () => {
      setLoadingDropdown(true);
      try {
        const response = await axios.get(`/user-filter-dropdown`);
        setDropdownData(response?.data);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setLoadingDropdown(false);
      }
    };
    fetchDropdownData();
  }, []);

  const fetchTableData = async (userType) => {
    setLoadingTable(true);
    try {
      const response = await axios.get(
        `/user-list-data/?user_type=${userType}`
      );
      setTableData(response?.data?.response);
    } catch (error) {
      console.error("Error fetching table data:", error);
    } finally {
      setLoadingTable(false);
    }
  };

  const handleChange = async (event) => {
    const userType = event.target.value;
    setSelectedValue(userType);
    fetchTableData(userType);
  };

  const handleRowClick =(row)=>{
    setSelectedRow(row)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false);
  }
  const labelId = "user-type-label";
  return (
    <>
      <Box p={4}>
        <Typography variant="h4" gutterBottom>
          User Subscription Details
        </Typography>

        {loadingDropdown ? (
          <CircularProgress />
        ) : (
          <FormControl fullWidth>
            <InputLabel id={labelId}>Select User Type</InputLabel>
            <Select
              labelId={labelId}
              id="user-type-select"
              value={selectedValue}
              label="Select User Type"
              onChange={handleChange}
            >
              {dropdownData.map((item, idx) => (
                <MenuItem key={idx} value={item.user_type}>
                  {item.user_type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {/* You can add your table rendering here later */}
        <Box mt={4}>
          {loadingTable ? (
            <CircularProgress />
          ) : (
            tableData.length > 0 ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        ID
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        Email
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        Mobile
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        User Type
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData &&
                      tableData.map((row) => (
                        <TableRow key={row.id} onClick ={() => handleRowClick(row)} sx={{
                            cursor:"pointer"
                        }} >
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{row.username}</TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>{row.phoneno}</TableCell>
                          <TableCell>{row.user_type}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) 
            :
            (
                <Typography>No data available</Typography>
            )
          )}
        </Box>
      </Box>
      {
        openModal && <UserSubscriptionDetailsModal  userId={selectedRow.id}  onClose={handleCloseModal}/> 
      }
    </>
  );
};

export default UsersSubscriptionDetails;
